import Breadcrumbs from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import {
  deleteBusinessUnit,
  listBusinessUnit,
  resetListBusinessUnit,
} from "store/actions";
import DetailUser from "./Detail";
import { userModeList, userRecordStatus, userRecordStatusMode } from "./utils";

const ListUser = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["businessUnit"]);
  const { addToast } = useToasts();

  const userManagement = useSelector(state => state.BusinessUnit);
  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader } = Dashboard;
  const {
    loadingList,
    errorList,
    list: userBusinessUnit,
    errorListRole,
    listRole: userRoleList,
    errorDelete,
    delete: userDelete,
    errorActive,
    active: userActive,
  } = userManagement;
  const [mode, setMode] = useState("");

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  const [dataDeleteUser, setDataDeleteUser] = useState({
    userId: null,
  });
  const [deleteUserModal, setDeleteUserModal] = useState(false);

  const [dataActiveUser, setDataActiveUser] = useState({
    userId: null,
  });
  const [activeUserModal, setActiveUserModal] = useState(false);

  const [columnsTable, setColumnsTable] = useState([]);

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    dispatch(
      listBusinessUnit({ ...userBusinessUnit.params, page: 1, sizePerPage: 10 })
    );
    initColumn();
    return () => {
      dispatch(resetListBusinessUnit());
    };
  }, [dispatch, t, tenantCodeHeader]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (userBusinessUnit) {
      setColumnsTable(initColumns);
    }

    if (userBusinessUnit.columnsVisible) {
      initColumn();
    }
  }, [userBusinessUnit]);

  const initColumn = () => {
    if (userBusinessUnit.columnsVisible) {
      for (const item of initColumns) {
        if (userBusinessUnit.columnsVisible[item.dataField] !== undefined) {
          item.hidden = !userBusinessUnit.columnsVisible[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  //Lưu lại column ẩn hiện
  const optionShowColumnHandler = (field, value) => {
    // dispatch(setListUserColumn(field, value));
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "record_status":
        if (prefix === "user") {
          options = userRecordStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    // Set option to select with Array values defined
    options.map(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    // Use For Column Formatter
    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "record_status":
        if (prefix === "user") {
          options = userRecordStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <Badge
            key={item.key}
            className={`font-size-12 ${item.badgeColor ? item.badgeColor : ""}`}
            pill
          >
            {selectOptionsTable(cell, name, prefix)}
          </Badge>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    userBusinessUnit.params.sort = sortField
      ? sortOrder + sortField
      : userBusinessUnit.params.sort;
    userBusinessUnit.params.columnFilter = columnFilter || {};
    userBusinessUnit.params.page = page || 1;
    userBusinessUnit.params.sizePerPage = sizePerPage || 10;
    dispatch(listBusinessUnit(userBusinessUnit.params));
  };

  const onSearchAllHandle = value => {
    userBusinessUnit.params.keywords = value;
    dispatch(listBusinessUnit(userBusinessUnit.params));
  };
  // Ẩn hiện modal inactive
  const toggleDeleteUserModal = () => {
    setDeleteUserModal(!deleteUserModal);
  };
  // Ẩn hiện modal active
  const toggleActiveUserModal = () => {
    setActiveUserModal(!activeUserModal);
  };

  // click button column action delete
  const clickDeleteUserHandler = (row, index) => {
    setDataDeleteUser({ userId: row.id });
    toggleDeleteUserModal();
  };

  // xác nhận delete
  const deleteSingleUserHandler = () => {
    dispatch(deleteBusinessUnit({ userId: dataDeleteUser.userId }));
    toggleDeleteUserModal();
  };

  // click button column action active
  const clickActiveUserHandler = (row, index) => {
    setDataActiveUser({ userId: row.id });
    toggleActiveUserModal();
  };

  // xác nhận active
  const activeSingleUserHandler = () => {
    toggleActiveUserModal();
  };
  useEffect(() => {
    if (userDelete && userDelete.success === true && userBusinessUnit) {
      dispatch(
        listBusinessUnit({
          ...userBusinessUnit.params,
          page: 1,
          sizePerPage: 10,
        })
      );
    }
  }, [userDelete]);
  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case userModeList.EDIT_USER_DETAIL:
        // dispatch(listBusinessUnit(userBusinessUnit.params));
        break;
      default:
        break;
    }
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ userId: row.id });
      setMode(userModeList.VIEW_USER_DETAIL);
      toggleDetailModal();
    },
  };
  const clickEditUserHandler = (row, index) => {
    if (row) {
      setDataDetail({ userId: row.id });
    } else {
      setDataDetail({});
    }
    setMode(userModeList.EDIT_USER_DETAIL);
    toggleDetailModal();
  };
  const listRowAction = [
    {
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.edit.user"),
      onClick: clickEditUserHandler,
    },
    {
      icon: <i className="fas fa-lg fa-trash-alt text-danger"></i>,
      text: t("table.actions.delete.user"),
      conditionVisible: {
        record_status: [userRecordStatusMode.ACTIVE],
      },
      onClick: clickDeleteUserHandler,
    },
    // {
    //   icon: <i className="fas fa-lock-open fa-lg text-success" />,
    //   text: t("table.actions.active.user"),
    //   conditionVisible: {
    //     record_status: [userRecordStatusMode.INACTIVE],
    //   },
    //   onClick: clickActiveUserHandler,
    // },
  ];

  const listMultipleRowAction = [
    {
      icon: <i className="bx bxs-check-circle font-size-18 text-success" />,
      text: "Ký duyệt mẫu hàng loạt",
      onClick: data => {
        if (data.length === 0) {
          addToast("Chưa chọn dòng nào", {
            appearance: "warning",
            autoDismiss: true,
          });
        } else {
          console.log("listMultipleRowAction", data);
        }
      },
    },
  ];

  const initColumns = [
    {
      dataField: "code",
      text: t("table.ma"),
      sort: true,
    },
    {
      dataField: "ten",
      text: t("table.ten"),
      sort: true,
    },
    {
      dataField: "sdthoai",
      text: t("table.sdthoai"),
      sort: true,
    },
    {
      dataField: "mst",
      text: t("table.mst"),
      sort: true,
    },
    {
      dataField: "dchi",
      text: t("table.dchi"),
      sort: true,
    },
    {
      dataField: "dctdtu",
      text: "Địa chỉ thư điện tử",
      sort: true,
    },
    {
      dataField: "send_mail",
      text: "Gửi mail khi phát hành hóa đơn thành công",
      sort: true,
      formatter: (cell, row) => {
        console.log("🚀 ~ file: List.js ~ line 320 ~ cell", cell);
        // "some" return boolean
        if (cell === 0) {
          return "Không tự động";
        } else {
          return "Tự động";
        }
      },
    },
    {
      dataField: "record_status",
      text: t("table.record_status.user.name"),
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.record_status.user.name"),
        }),
        options: selectOptionsTable(undefined, "record_status", "user"),
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell && userRecordStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "record_status", "user");
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={userBusinessUnit.params.columnFilter}
        />
      ),
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      filter: textFilter({
        placeholder: t("placeholder.enter", {
          title: t("table.checker_id"),
        }),
      }),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : cell;
      },
    },
  ];

  const selectRowCheckbox = {
    mode: "checkbox",
  };

  const onRowsSelect = data => {
    console.log("onRowsSelect", data);
  };

  return (
    <React.Fragment>
      <div className="page-content badge-soft ">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title={t("title.manager")}
            breadcrumbItem={
              t("title.list") + ` (${userBusinessUnit.totalCount})`
            }
          />
          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Detail Modal */}
              <DetailUser
                dataDetail={dataDetail}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
                userRoleList={userRoleList}
                userBusinessUnit={userBusinessUnit}
              />
              {/* Delete User Modal */}
              <ConfirmModal
                isOpen={deleteUserModal}
                titleHeader={t("form.submit.delete.user.confirm.header")}
                titleBody={t("form.submit.delete.user.confirm.body")}
                onConfirm={deleteSingleUserHandler}
                textBtnConfirm={t("form.submit.delete.user.confirm.agree")}
                textBtnCancel={t("form.submit.delete.user.confirm.cancel")}
                toggle={toggleDeleteUserModal}
              />
              {/* Active User Modal */}
              <ConfirmModal
                isOpen={activeUserModal}
                titleHeader={t("form.submit.active.user.confirm.header")}
                titleBody={t("form.submit.active.user.confirm.body")}
                onConfirm={activeSingleUserHandler}
                textBtnConfirm={t("form.submit.active.user.confirm.agree")}
                textBtnCancel={t("form.submit.active.user.confirm.cancel")}
                toggle={toggleActiveUserModal}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    onRowsSelect={onRowsSelect}
                    keyField="id"
                    data={userBusinessUnit.items}
                    columns={columnsTable}
                    page={userBusinessUnit.params.page}
                    sizePerPage={userBusinessUnit.params.sizePerPage}
                    totalSize={userBusinessUnit.totalCount}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listRowAction={listRowAction}
                    loading={loadingList}
                  >
                    <div
                      onClick={() => clickEditUserHandler()}
                      className="btn btn-primary btn-label"
                    >
                      <i className="fas fa-plus label-icon" />
                      {t("title.create")}
                    </div>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListUser;
